// Spec 2026-10-09 §3/§9 — dönem süre uzatma çekmecesinin SAF yardımcıları (UTC gün aritmetiği;
// 'yyyy-MM-dd' girer/çıkar — PeriodWizard'ın tarih sözleşmesiyle aynı).
export const EXTENDABLE_STATUSES = ['active', 'evaluation', 'calibration'];
export const REASON_CODES = ['low_participation', 'holiday_leave', 'org_change', 'technical_issue', 'other'];

export const toDay = (iso) => (iso ? String(iso).slice(0, 10) : '');

const parse = (day) => {
  const [y, m, d] = day.split('-').map(Number);
  return Date.UTC(y, m - 1, d);
};

export const addDays = (day, n) => {
  if (!day) return '';
  return new Date(parse(day) + n * 86400000).toISOString().slice(0, 10);
};

export const diffDays = (a, b) => Math.round((parse(a) - parse(b)) / 86400000);

// Değişmeyen tarih null gider (sunucu "değişmiyor" okur); beklenen tarihler istemcinin gördüğü
// MEVCUT değerlerdir (eşzamanlılık bekçisi).
export function buildExtendPayload(period, values) {
  const changed = (value, current) => (value && value !== toDay(current) ? value : null);
  return {
    expectedEvalWindowEnd: period.evalWindowEnd,
    expectedCalibWindowStart: period.calibWindowStart,
    expectedCalibWindowEnd: period.calibWindowEnd,
    newEvalWindowEnd: period.status === 'calibration' ? null : changed(values.newEvalWindowEnd, period.evalWindowEnd),
    newCalibWindowStart: changed(values.newCalibWindowStart, period.calibWindowStart),
    newCalibWindowEnd: changed(values.newCalibWindowEnd, period.calibWindowEnd),
    reasonCode: values.reasonCode,
    note: values.note ? values.note.trim() : null,
  };
}
